import React, { useContext, useEffect, useRef, useState } from "react";
import PageNav from "../components/PageNav";
// import { Notesvg } from "../svg/Notesvg";
import Card from "../components/common/Card";
import { Lessons } from "../components/Lessons";
import videoTabImg from "../images/videoTabImg.png";
import axios from "axios";
import { toTitleCase } from '../util/titleCase';
import { AuthContext } from "../context/AuthContext";
import { DataContext } from "../context/DataContext";

import ReactPlayer from "react-player/lazy";
import { animated, useSpring } from "react-spring";
import classNames from "classnames";
// import VideoSvg from "../svg/AudioSvg";
import useOnClick from "../components/common/ClosePopUp";

const VideoLessons = () => {
  const authContext = useContext(AuthContext);
  const dataContext = useContext(DataContext);
  const [currentVideo, setCurrVideo] = useState();
  const [videos, setVideos] = useState([]);
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [displayTermDropdown, setDisplayTermDropdown] = useState(false);
  const [clickedDropdown, setClickedDropdown] = useState("Select Title");
  const [termDropdown, setTermDropdown] = useState("Select Term");
  // const [filteredVideos, setFilteredVideos] = useState(false);
  const [showState, setShowState] = useState('default');
  const [sessionTerms, setSessionTerms] = useState([{term : "All terms"}])

  const id = JSON.parse(localStorage.getItem("studentInfo"));
  const studentId = id[0].studentId;
  const schoolDomain = localStorage.getItem('schoolDomain');
  const deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;

  const videoDetails = [];

  const ref = useRef();
  const termRef = useRef();

  const showDropdown = classNames({
    "hidden": !displayDropdown,
    "bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500": true
  });

  const showTermDropdown = classNames({
    "hidden": !displayTermDropdown,
    "bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500": true
  });

  const transitionStyles = useSpring({
    to: [
      { opacity: 1, transform: 'translateX(0)' },
    ],
    from: { opacity: 0, transform: 'translateX(80px)' },
    config: { duration: 1000 }
  });

  // const videoDataExtract = (video) => {
  //     video.length && video.map( item => {
  //         return typeof item.Available_Videos === "object" && item.Available_Videos.map( video => {
  //             return videoDetails.push({topic: video.topic, url: video.longurl});
  //         })
  //     });
  // }
  // videoDataExtract(studentVideos)

  // console.log(videoDetails.length);

  const [playerWidth, setPlayerWidth] = useState(300);
  const playerContainerRef = useRef()
  useEffect(() => {
    const calculatePlayerWidth = () => (
        playerContainerRef.current.innerWidth < 640
          ? playerContainerRef.current.innerWidth * 0.9 
          : playerContainerRef.current.innerWidth * 2 / 3 * 0.9
    );

    const handleResize = () => {
      setPlayerWidth(calculatePlayerWidth());
    };
    setPlayerWidth(calculatePlayerWidth());
    playerContainerRef.current.addEventListener("resize", handleResize);
    return () => {
      playerContainerRef.current.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const updatedUrl = dataContext.clickedVideoUrl;
    setCurrVideo(updatedUrl);
  }, [dataContext.clickedVideoUrl]);

  useEffect(() => {
    const getStudentVideos = async () => {
      try {
        const { data } = await axios.get(
          `/student/getallvideoNew/${schoolDomain}/${studentId}/${deploymentIdx}`
        );
        // console.log(data);
        setVideos(data.data);
      } catch (error) {
        // console.log(error);
      }
      // Get school terms
      try {
        const { data } = await axios.get(`${authContext.baseUrl}/getschoolterm/${schoolDomain}`);
        setSessionTerms(initial => [...initial, ...data.data]);
        // console.log(data.data);
    } catch (error) {
        // console.log('Terms fetch error', error)
    }
    };
    getStudentVideos();
    // console.log(dataContext.initialVideo);
  }, [dataContext.initialVideo, authContext.baseUrl, schoolDomain, studentId]);

  const handleClickedFilter = (item) => {
    // alert(item);
    setClickedDropdown(item);
    setDisplayDropdown(!displayDropdown);
    setShowState('filter')
  };

  const handleClickedTermFilter = (item) => {
    setTermDropdown(item);
    setDisplayTermDropdown(!displayTermDropdown);
    item !== 'All terms' ? setShowState('term') : setShowState('default') 
  };

  useOnClick(ref, () => setDisplayDropdown(false));
  useOnClick(termRef, () => setDisplayTermDropdown(false));

  const Heading = () => (
    <>
      <span className="text-2xl leading-7 text-white mt-1"> Videos </span>
    </>
  );
  const pageSvg = () => (
    <>
      <img classNames="w-16 sm:w-full" src={videoTabImg} alt="video" />
    </>
  );

  return (
    <>
      <animated.div style={transitionStyles} className="px-4 sm:flex sm:px-0 h-full">
        <div className=" sm:w-2/3 sm:pl-0 sm:mb-auto md:w-full md:px-4 h-full mb-12">
          <PageNav Heading={Heading} PageSvg={pageSvg} />
          <div className=" w-full">
            <div className="flex items-center space-x-4">
              <span className="font-bold mt-4 sm:block hidden"> Filter: </span>

              <div ref={termRef} className="flex flex-col relative mt-4">
                <span onClick={() => setDisplayTermDropdown(!displayTermDropdown)} className="flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer">
                  <span className="leading-4 text-xs text-gray-100 mr-3"> {toTitleCase(termDropdown)} </span>
                  <span className="pt-1">
                      <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z" fill="#000114" />
                      </svg>
                  </span>
                </span>
                <ul className={showTermDropdown}>
                  {sessionTerms && sessionTerms.map((item, index) => {
                    return (
                    <li key={index} onClick={() => handleClickedTermFilter(item.term)} className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100">
                        {toTitleCase(item.term)}
                    </li>
                  )})}
                </ul>
              </div>

              <div ref={ref} className="flex flex-col relative mt-4">
                <span onClick={() => setDisplayDropdown(!displayDropdown)} className="flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer">
                  <span className="leading-4 text-xs text-gray-100 mr-3"> {toTitleCase(clickedDropdown)} </span>
                  <span className="pt-1">
                      <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z" fill="#000114" />
                      </svg>
                  </span>
                </span>
                <ul className={showDropdown}>
                  {videos && videos.map(item => {
                    return (
                    <li onClick={() => handleClickedFilter(item.topic)} className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100">
                        {toTitleCase(item.topic)}
                    </li>
                  )})}
                </ul>
              </div>
            </div>

            {showState === 'term' &&
              <div className="w-full flex my-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 col-gap-8 row-gap-4 justify-center ml-12 sm:ml-0 ">
                  {videos && videos.length > 0 && videos.filter(video => video.term === termDropdown).map(video => {
                    // console.log(video)
                      return (
                        <Card>
                          <div className="w-full pb-4 mr-3 flex justify-center">
                            <ReactPlayer
                              url={video.longurl}
                              style={{ borderRadius: "4px" }}
                              width={playerWidth}
                              playsinline={true}
                              controls={true}
                              pip={true}
                              // playIcon
                              //volume = '2'
                            />
                            <div className="flex justify-center items-center h-10">
                              <span className="flex justify-center items-center text-xs text-gray-200 font-bold leading-4">
                                {" "}
                                {video.topic}{" "}
                              </span>
                            </div>
                          </div>
                        </Card>
                      );
                    })}
                </div>
              </div>
            }

            { showState === 'filter' &&
              <div className='w-full my-4'>
                { videos && videos.length > 0 && videos.filter(video => video.topic === clickedDropdown).map(video =>
                  <div className="w-full sm:w-1/2 flex justify-center"> 
                    <ReactPlayer
                      url={video.longurl}
                      width={playerWidth}
                      playsinline={true}
                      controls={true}
                      pip={true}
                      // playIcon
                    />
                  </div>
                )}
              </div>
            }

            { showState === 'default' &&
            <>
              <div className="md:block">
                <div className="text-base text-gray-100 font-semibold my-5 sm:block">
                  {" "}
                  Recent Lessons{" "}
                </div>
                <div ref={playerContainerRef} className="w-full md:flex">
                  <div className="w-full md:w-2/3 sm:w-1/2 flex justify-center">
                    {currentVideo ? (
                      <ReactPlayer
                        url={currentVideo}
                        playsinline={true}
                        controls={true}
                        pip={true}
                        width={playerWidth}
                      />
                    ) : (
                      <ReactPlayer
                        url={videos && videos.length > 0 && videos[0].longurl ? videos[0].longurl : ''}
                        width={playerWidth}
                        playsinline={true}
                        controls={true}
                        pip={true}
                      />
                    )}
                  </div>
                  <div className="w-full mt-6 md:w-1/3 mb-24 md:ml-6">
                    <Lessons />
                  </div>
                </div>
              </div>
              <div className="mt-2 w-full">
                {videos && videos.length > 4 ?
                <>
                  <span className="text-base text-gray-100 font-semibold my-5 hidden sm:block">
                  {" "}
                  Other Lessons{" "}
                  </span>
                  <span className="text-base text-gray-100 font-semibold my-12 block sm:hidden">
                    Lessons
                  </span> 
                </>: 
                ''}
                <div className="w-full flex my-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 col-gap-8 row-gap-4 justify-center ml-12 sm:ml-0 ">
                    {videos && videos.length > 0 &&
                      videos.slice(4).map((video) => {
                        return (
                          <Card>
                            <div className="w-full pb-4 mr-3 flex justify-center">
                              <ReactPlayer
                                url={video.longurl}
                                style={{ borderRadius: "4px" }}
                                width={playerWidth}
                                playsinline={true}
                                controls={true}
                                pip={true}
                              />
                              <div className="flex justify-center items-center h-10">
                                <span className="flex justify-center items-center text-xs text-gray-200 font-bold leading-4">
                                  {" "}
                                  {video.topic}{" "}
                                </span>
                              </div>
                            </div>
                          </Card>
                        );
                      })}
                  </div>
                </div>
              </div>
            </>
            }
          </div>
        </div>
      </animated.div>
    </>
  );
};

export default VideoLessons;
